module.exports = __webpack_public_path__ + "ath_game_web/img/7.2.2.16eae2dc.png";